import React from "react"
import ForgotPasswordForm from "../../sections/ForgotPasswordForm/ForgotPasswordForm"
import "./ForgotPassword.css"

function ForgotPassword() {
  return (
    <main className='ForgotPassword auth-page'>
      <ForgotPasswordForm />
    </main>
  )
}

export default ForgotPassword
